// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G2bM9","left":"styles_left__124kw"};